import { render, staticRenderFns } from "./PortfolioParticipationChart.vue?vue&type=template&id=65131cca"
import script from "./PortfolioParticipationChart.vue?vue&type=script&lang=js"
export * from "./PortfolioParticipationChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports